//  fullscreen START
$('#fsbc').hide();
var elem = document.documentElement;
function openFullscreen() {
  if (elem.requestFullscreen) {
    elem.requestFullscreen();
    $('body').addClass('chart-fullscreen');
    $('#container').addClass('active');
    $('body').addClass('noverfl');
    $('#fsbo').hide();
    $('#fsbc').show();
  } else if (elem.mozRequestFullScreen) { /* Firefox */
    elem.mozRequestFullScreen();
    $('#container').addClass('active');
    $('body').addClass('noverfl');
    $('#fsbo').hide();
    $('#fsbc').show();
  } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
    elem.webkitRequestFullscreen();
    $('#container').addClass('active');
    $('body').addClass('noverfl');
    $('#fsbo').hide();
    $('#fsbc').show();
  } else if (elem.msRequestFullscreen) { /* IE/Edge */
    elem.msRequestFullscreen();
    $('#container').addClass('active');
    $('body').addClass('noverfl');
    $('#fsbo').hide();
    $('#fsbc').show();
  }
}

function closeFullscreen() {
  $('body').removeClass('chart-fullscreen');
  $('#container').removeClass('active');
  $('body').removeClass('noverfl');
  $('#fsbo').show();
  $('#fsbc').hide();
  if (document.exitFullscreen) {
    document.exitFullscreen();
    $('#fsbo').show();
    $('#fsbc').hide();
    $('#container').removeClass('active');
    $('body').removeClass('noverfl');
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
    $('#fsbo').show();
    $('#fsbc').hide();
    $('#container').removeClass('active');
    $('body').removeClass('noverfl');
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
    $('#container').removeClass('active');
    $('body').removeClass('noverfl');
    $('#fsbo').show();
    $('#fsbc').hide();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
    $('#container').removeClass('active');
    $('body').removeClass('noverfl');
    $('#fsbo').show();
    $('#fsbc').hide();
  }
}
document.addEventListener('fullscreenchange', exitHandler);
document.addEventListener('webkitfullscreenchange', exitHandler);
document.addEventListener('mozfullscreenchange', exitHandler);
document.addEventListener('MSFullscreenChange', exitHandler);
function exitHandler() {
    if (!document.fullscreenElement && !document.webkitIsFullScreen && !document.mozFullScreen && !document.msFullscreenElement) {
        $('body').removeClass('chart-fullscreen');
        $('#container').removeClass('active');
        $('body').removeClass('noverfl');
        $('#fsbo').show();
        $('#fsbc').hide();
    }
    $box.height( $box.width() * aspect_ratio );
}
// fullscreen END




menuGroup();

radioSizes();

menuMA();

marketsMenu();



$('#exChanges').css('display','block');
$('#tv-bar').css('display','inline-block');

$('.modal #tv-bar').css('display','inline-block');



// Functions________________________________________________________________________


// MA menu
function menuMA(){
$('html').click(function() {
  if ($("#MA-menu").hasClass("active")){
    $("#MA-menu").removeClass("active");
    $("#chartoverlay").remove();
  }
});
// Open menu
$("#openMA-menu").click(function(event) {
  event.preventDefault();
  event.stopPropagation();
  if ($("#MA-menu").hasClass("active")) {
    $("#MA-menu").removeClass('active');
    $("#chartoverlay").remove();
  } else {
    $("#MA-menu").addClass('active');
    $(".modal #chartcontent").prepend('<span id="chartoverlay"></span>');
    $("#chartoverlay").click(function() {
      $("#chartoverlay").remove();
    });
  }
});
}

// chart header markets menu
function marketsMenu(){
$('html').click(function() {
  if (!$(event.target).is("#searchMarketsHeader")) {
    if ($("#marketsMenuDropdown").hasClass("active")){
      $("#marketsMenuDropdown").removeClass("active");
      $("#chartoverlay").remove();
    }
  }
});
// Open menu
$("#marketsMenu").click(function(event) {
  event.preventDefault();
  event.stopPropagation();
  if ($("#marketsMenuDropdown").hasClass("active")) {
    $("#marketsMenuDropdown").removeClass('active');
    $("#chartoverlay").remove();
  } else {
    $("#marketsMenuDropdown").addClass('active');
    $(".modal #chartcontent").prepend('<span id="chartoverlay"></span>');
    $("#chartoverlay").click(function() {
      $("#chartoverlay").remove();
    });
  }
});
}

// exChange menu
function menuGroup(){
$('html').click(function() {
  if ($(".menu-trigger").hasClass("active")){
    $(".menu-trigger").removeClass("active");
  }
  if ($(".menu-dropdown").hasClass("open")){
    $(".menu-dropdown").removeClass("open").addClass("closed");
  }
});
// Open menu
$(".menu-trigger").click(function(event) {
  event.preventDefault();
  event.stopPropagation();
  $(this).toggleClass("active");
  if($(this).next('.menu-dropdown').hasClass("closed")){
    $(this).next(".menu-dropdown").removeClass("closed").addClass("open");
  }
});
}


function searchMarketsHeader() {

    var input = document.getElementById("searchMarketsHeader");
    var filter = input.value.toUpperCase();
    var isMatchMkt = false;
    var lisMkts = document.querySelectorAll('#headerMarkets table tr');
    for (var i = 0; i < lisMkts.length; i++) {
        var name = lisMkts[i].textContent.toUpperCase();
        if (name.toUpperCase().indexOf(filter) == -1) {
            lisMkts[i].classList.add("hide")
        } else {
            lisMkts[i].classList.remove("hide")
            isMatchMkt = true;
        }
    }

    $('#noMarketsHeader').toggle(!isMatchMkt);

}



function radioSizes(){
$('[data-set*="radio-currency-set"]').click(function(){
  var parent = $(this).closest(".set-parent");
  var selected = $(this);
  $(".radio-display", parent).attr("data-exch", selected.attr("id"));
  $(".radio-display .currency-label", parent).html(selected.attr("id"));
});
}
